import React, { RefAttributes, forwardRef, useContext } from "react";

import { FaClipboardList, FaExclamationCircle, FaUserCheck, FaUserEdit } from "react-icons/fa";
import { EOBActualProps } from "../../../../../../../../@types/components/EOB.types";

// import { BiSolidReport } from "react-icons/bi";
import { HiBadgeCheck } from "react-icons/hi";
import PropTypes from "prop-types";

import "./explanationOfBenefitFormPrint.css";
import ExplanationOfBenefitsGridPrint from "./ExplanationOfBenefitsGridPrint/ExplanationOfBenefitsGridPrint";
import { ThemeContext } from "../../../../../../../../contexts";
import { BrookshireBrothersCircleLogo, nexcaliberLogo } from "../../../../../../../../assets";
import { NEXCALIBER_DETAILS } from "../../../../../../../../constants/nexcaliberDetails";
import { Member } from "../../../../../../../../@types/member.types";
import { dollarize } from "../../../../../../../../utils/commonFunctions/dollar";
import AssessmentIcon from "@material-ui/icons/Assessment";

const ExplanationOfBenefitFormPrint: React.ForwardRefExoticComponent<
	EOBActualProps & { member: Member } & RefAttributes<HTMLDivElement>
> = forwardRef<HTMLDivElement, EOBActualProps & { member: Member }>(
	({ EOBDetails, summary, member }, ref): JSX.Element => {
		const { theme } = useContext(ThemeContext);

		return (
			<div className="printable-EOB" ref={ref}>
				<div className="EOB-paper-container">
					{/* ============================= HEADER CONTAINER ================================= */}
					<div className="header-container">
						<div className="group-logo-container">
							<img src={BrookshireBrothersCircleLogo} className="group-logo" alt="" />
						</div>
						<div className="nexcaliber-logo-container">
							<img src={nexcaliberLogo} className="nexcaliber-logo" alt="" />
							<div className="nexcaliber-location-details">
								<span>Nexcaliber</span>
								<span>PO BOX 802422, Dalas Texas 75380</span>
								<span>{NEXCALIBER_DETAILS.NEXCALIBER_CONTACT}</span>
							</div>
						</div>
					</div>
					<div className="subheading-main" style={{ color: theme.primary_color }}>
						<HiBadgeCheck />
						Explanation of Benefits
					</div>
					{/* ============================= BODY CONTAINER ====================================*/}
					<div className="eob-grid-container">
						<div className="eob-grid-item">
							<div className="category-heading" style={{ color: theme.primary_color }}>
								<FaUserCheck />
								<span>Subscriber</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">First Name</span>
								<span className="field-value">
									{EOBDetails.claimant.patient_name.substring(
										0,
										EOBDetails.claimant.patient_name.indexOf(" ")
									)}
								</span>
							</div>
							<span className="grid-item-fields">
								<div className="grid-item-fields">
									<span className="field-title">Last Name</span>
									<span className="field-value">
										{EOBDetails.claimant.patient_name.split(" ")[1]}
									</span>
								</div>
							</span>
							<span className="grid-item-fields">
								<div className="grid-item-fields">
									<span className="field-title">Address</span>
									<span className="field-value">{member.address_line_1}</span>
									<span className="field-value">
										{member.city + ", " + member.state + " " + member.ZIP}
									</span>
								</div>
							</span>
						</div>
						<div className="eob-grid-item">
							<div className="category-heading" style={{ color: theme.primary_color }}>
								<FaUserEdit />
								<span>Claimant</span>
							</div>
							<div className="claimant-container">
								<div className="left-section">
									<div className="grid-item-fields">
										<span className="field-title">SSN</span>
										<span className="field-value">{EOBDetails.claimant.SSN}</span>
									</div>

									<div className="grid-item-fields">
										<span className="field-title">Claim For</span>
										<span className="field-value">{EOBDetails.claimant.patient_name}</span>
									</div>

									<div className="grid-item-fields">
										<span className="field-title">Patient Number :</span>
										<span className="field-value">{EOBDetails.claimant.patient_account}</span>
									</div>

									<div className="grid-item-fields">
										<span className="field-title">Claim Number :</span>
										<span className="field-value">{EOBDetails.claimant.full_claim_number}</span>
									</div>
								</div>
								<div className="right-section">
									<div className="grid-item-fields">
										<span className="field-title">Paid Date :</span>
										<span className="field-value">04-22-2023</span>
									</div>
								</div>
							</div>
						</div>
						<div className="eob-grid-item">
							<div className="category-heading" style={{ color: theme.primary_color }}>
								<FaClipboardList />
								<span>Provider Details</span>
							</div>
							<span>{EOBDetails.provider.full_provider_number}</span>
							<span>{EOBDetails.provider.name}</span>
							<span>{EOBDetails.provider.address_line_1}</span>
							<span>
								{EOBDetails.provider.city}, {EOBDetails.provider.state}, {EOBDetails.provider.zipcode}
							</span>
							<span>{EOBDetails.provider.PPO}</span>
						</div>
						<div className="eob-grid-item">
							<div className="category-heading" style={{ color: theme.primary_color }}>
								<FaExclamationCircle />
								<span>Claim Summary</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">Total Amount Covered:</span>
								<span className="field-value">{dollarize(summary.totalAmountCovered)}</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">Paid by Insurrance company:</span>
								<span className="field-value">{dollarize(summary.paidByOtherInsuranceCo)}</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">Total Paid By plans:</span>
								<span className="field-value">{dollarize(summary.totalPaidByPlan)}</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">Employee Responsibility:</span>
								<span className="field-value">{dollarize(summary.copay)}</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">Deductible Remaining:</span>
								<span className="field-value">N/A</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">In Network:</span>
								<span className="field-value">N/A</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">Out OF Pocket Remaining Plan:</span>
								<span className="field-value">N/A</span>
							</div>
							<div className="grid-item-fields">
								<span className="field-title">Annual Accumulation:</span>
								<span className="field-value">N/A</span>
							</div>
						</div>
					</div>
					{/* ============================= CLAIM DETAILS ====================================*/}
					<div className="subheading-main" style={{ color: theme.primary_color }}>
						<AssessmentIcon />
						Claim Details
					</div>

					<ExplanationOfBenefitsGridPrint claimLinesProps={EOBDetails.claimLines} />
				</div>
			</div>
		);
	}
);

ExplanationOfBenefitFormPrint.displayName = "EOBPrint";
ExplanationOfBenefitFormPrint.propTypes = {
	EOBDetails: PropTypes.any.isRequired,
	summary: PropTypes.any.isRequired
};

export default ExplanationOfBenefitFormPrint;
